import * as React from 'react';
import { FlattenInterpolation, ThemedStyledProps } from 'styled-components';

import * as S from './styles';

export interface LoadingCircleProps
  extends React.SVGAttributes<HTMLOrSVGElement> {
  wrapCss?: FlattenInterpolation<ThemedStyledProps<any, any>>;
  circleCss?: FlattenInterpolation<ThemedStyledProps<any, any>>;
  isLoading?: boolean;
}

export default function LoadingCircle({
  className,
  wrapCss,
  circleCss,
  isLoading,
  ...rest
}: LoadingCircleProps) {
  return (
    <>
      {isLoading && (
        <S.LoadingCircleWrap className={className} wrapCss={wrapCss} {...rest}>
          <S.LoadingCircle circleCss={circleCss} />
        </S.LoadingCircleWrap>
      )}
    </>
  );
}

LoadingCircle.propTypes = {
  // loading: PropTypes.bool,
};

LoadingCircle.defaultProps = {
  // loading: false,
};
